import $ from 'jquery';
import 'magnific-popup';

(function($) {
    "use strict";

    // Popup image
    $('.popup-img').magnificPopup({
        type: 'image',
        gallery: {
            tPrev: 'Précédent',
            tNext: 'Suivant',
            tCounter: '%curr% de %total%',
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
        },
    });

})(jQuery);

